/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type { TelegramConfigsControllerFindAllQueryResponse } from '../../types/TelegramConfigsControllerFindAll.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramConfigsFindAll } from '../../methods/telegramConfigsFindAll.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramConfigsFindAllQueryKey = () => [{ url: '/api/telegram/configs' }] as const;

export type TelegramConfigsFindAllQueryKey = ReturnType<typeof telegramConfigsFindAllQueryKey>;

export function telegramConfigsFindAllQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = telegramConfigsFindAllQueryKey();
  return queryOptions<
    TelegramConfigsControllerFindAllQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramConfigsControllerFindAllQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramConfigsFindAll(config);
    },
  });
}

/**
 * {@link /api/telegram/configs}
 */
export function useTelegramConfigsFindAll<
  TData = TelegramConfigsControllerFindAllQueryResponse,
  TQueryData = TelegramConfigsControllerFindAllQueryResponse,
  TQueryKey extends QueryKey = TelegramConfigsFindAllQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramConfigsControllerFindAllQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramConfigsFindAllQueryKey();

  const query = useQuery(
    {
      ...telegramConfigsFindAllQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
